import {create} from 'zustand';

type FontFamilyNameState = {
  fontFamilyName: string | null;
  setFontFamilyName: (name: string) => void;
};

export const useFontFamilyName = create<FontFamilyNameState>(set => ({
  fontFamilyName: null,
  setFontFamilyName: fontFamilyName => {
    set({fontFamilyName});
  },
}));
